export const TOKEN_KEYS = {
  ACCESS_TOKEN: 'accessToken',
  REFRESH_TOKEN: 'refreshToken',
  USER_ID: 'userId'
} as const;

export const authUtils = {
  // Сохранение токенов
  setTokens: (accessToken: string, refreshToken: string) => {
    localStorage.setItem(TOKEN_KEYS.ACCESS_TOKEN, accessToken);
    localStorage.setItem(TOKEN_KEYS.REFRESH_TOKEN, refreshToken);
  },

  // Получение токенов
  getAccessToken: (): string | null => {
    return localStorage.getItem(TOKEN_KEYS.ACCESS_TOKEN);
  },

  getRefreshToken: (): string | null => {
    return localStorage.getItem(TOKEN_KEYS.REFRESH_TOKEN);
  },

  // Сохранение ID пользователя
  setUserId: (userId: string) => {
    localStorage.setItem(TOKEN_KEYS.USER_ID, userId);
  },

  // Получение ID пользователя
  getUserId: (): string | null => {
    return localStorage.getItem(TOKEN_KEYS.USER_ID);
  },

  /**
   * Извлекает userId из access-токена (JWT).
   * Бэкенд кладёт идентификатор пользователя в claim `sub` (фолбэки — `userId`/`id`).
   * Нужен для OAuth-флоу, где в редиректе приходят только токены без userId.
   */
  getUserIdFromAccessToken: (accessToken: string): string | null => {
    try {
      const payload = accessToken.split('.')[1];
      if (!payload) return null;
      // base64url -> base64 + корректное декодирование UTF-8
      const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
      const json = decodeURIComponent(
        atob(base64)
          .split('')
          .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
          .join('')
      );
      const data = JSON.parse(json);
      const id = data?.sub ?? data?.userId ?? data?.id;
      return id != null ? String(id) : null;
    } catch {
      return null;
    }
  },

  // Проверка авторизации
  isAuthenticated: (): boolean => {
    return !!(authUtils.getAccessToken() && authUtils.getUserId());
  },

  // Обновление токена
  updateAccessToken: (newAccessToken: string) => {
    localStorage.setItem(TOKEN_KEYS.ACCESS_TOKEN, newAccessToken);
  },

  // Очистка всех данных авторизации
  clearAuth: () => {
    localStorage.removeItem(TOKEN_KEYS.ACCESS_TOKEN);
    localStorage.removeItem(TOKEN_KEYS.REFRESH_TOKEN);
    localStorage.removeItem(TOKEN_KEYS.USER_ID);
  }
};
